export class UtilitiesHelper {

  static calculateAge(
    dataNascita: string
  ): number {

    if (!dataNascita) {
      return 0;
    }

    const birthDate =
      new Date(dataNascita);

    const today =
      new Date();

    let age =
      today.getFullYear()
      -
      birthDate.getFullYear();

    const monthDiff =
      today.getMonth()
      -
      birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (
        monthDiff === 0 &&
        today.getDate() <
        birthDate.getDate()
      )
    ) {

      age--;
    }

    return age;
  }

  static getTrendIcon(
    currentValue: number,
    previousValue: number
  ): string {

    if (
      currentValue == null ||
      previousValue == null
    ) {

      return 'fa-minus';
    }

    if (currentValue > previousValue) {

      return 'fa-arrow-up';
    }

    if (currentValue < previousValue) {

      return 'fa-arrow-down';
    }

    return 'fa-equals';
  }

  static getTrendClass(
    currentValue: number,
    previousValue: number
  ): string {

    if (
      currentValue > previousValue
    ) {

      return 'text-danger';
    }

    if (
      currentValue < previousValue
    ) {

      return 'text-success';
    }

    return 'text-secondary';
  }

  static getDelta(
    currentValue: number,
    previousValue: number
  ): number {

    return Number(
      (
        currentValue -
        previousValue
      ).toFixed(1)
    );
  }

  static calculateBmi(
    peso: number | null | undefined,
    altezza: number | null | undefined
  ): number | null {

    if (
      !peso ||
      !altezza
    ) {

      return null;
    }

    const altezzaMetri =
      altezza / 100;

    return Number(
      (
        peso /
        (
          altezzaMetri *
          altezzaMetri
        )
      ).toFixed(2)
    );
  }


  static getBmiDescription(bmi: number): string {

    if (!bmi) {
      return '';
    }

    if (bmi < 18.5) {
      return 'Sottopeso';
    }

    if (bmi < 25) {
      return 'Normopeso';
    }

    if (bmi < 30) {
      return 'Sovrappeso';
    }

    return 'Obesità';
  }

  static getBmiIconClass(
    bmi: number | null
  ): string {

    if (!bmi) {

      return 'fa-circle text-secondary';
    }

    if (bmi < 18.5) {

      return 'fa-circle text-info';
    }

    if (bmi < 25) {

      return 'fa-circle text-success';
    }

    if (bmi < 30) {

      return 'fa-circle text-warning';
    }

    return 'fa-circle text-danger';
  }

  static calculateWaistHipRatio(
    vita: number | null,
    fianchi: number | null
  ): number | null {

    if (
      !vita ||
      !fianchi
    ) {

      return null;
    }

    return Number(
      (
        vita /
        fianchi
      ).toFixed(2)
    );
  }

  static getWaistHipDescription(
    rapporto: number | null,
    genere: string | null
  ): string {

    if (
      !rapporto ||
      !genere
    ) {

      return '';
    }

    const soglia =

      genere === 'F'
        ? 0.80
        : 0.90;

    return rapporto < soglia
      ? 'Normale'
      : 'Rischio';
  }

  static getWaistHipIcon(
    rapporto: number | null,
    genere: string | null
  ): string {

    if (
      !rapporto ||
      !genere
    ) {

      return 'fa-circle text-secondary';
    }

    const soglia =

      genere === 'F'
        ? 0.80
        : 0.90;

    return rapporto < soglia

      ? 'fa-circle text-success'

      : 'fa-circle text-danger';
  }

  static getWaistHipBadgeClass(
    rapporto: number | null,
    genere: string | null
  ): string {

    if (
      !rapporto ||
      !genere
    ) {

      return 'bg-secondary';
    }

    const soglia =

      genere === 'F'
        ? 0.80
        : 0.90;

    return rapporto < soglia
      ? 'bg-success'
      : 'bg-danger';
  }

  static getSfgeDescription(
    score: number | null
  ): string {

    if (!score) {

      return '';
    }

    if (score <= 5) {

      return 'Basso rischio';
    }

    if (score <= 10) {

      return 'Rischio moderato';
    }

    if (score <= 15) {

      return 'Rischio elevato';
    }

    return 'Rischio molto elevato';
  }

  static getSfgeIcon(
    score: number | null
  ): string {

    if (!score) {

      return 'fa-circle text-secondary';
    }

    if (score <= 5) {

      return 'fa-circle text-success';
    }

    if (score <= 10) {

      return 'fa-circle text-warning';
    }

    if (score <= 15) {

      return 'fa-circle text-danger';
    }

    return 'fa-triangle-exclamation text-danger';
  }

}